import { key, keyCodes } from './helpers';

jQuery(function ($) {
  function isMobile() {
    return $(window).width() < 900;
  }
  const SUBMENU_ITEMS = '.side-menu__item > a, .side-menu__item > [role="button"]';
  const navbarMenu = $('.navbar-menu');
  let url;

  function addMenuListeners(level) {
    const menu = $(`.side-menu[data-level="${level}"]`);

    // Clear listeners
    $('.side-menu__item.has-children', menu).off('keypress click mouseenter');

    // Click / keypress
    $('.side-menu__item.has-children', menu).interact(function (e) {
      const focusItem = e.type !== 'click' && level > 0;
      openSubMenu(e.target, focusItem);
    });

    // Hover on desktop
    $('.side-menu__item.has-children', menu).on('mouseenter', function (e) {
      if (!isMobile()) {
        openSubMenu(e.target);
      }
    });

    // IMPORTANT: This is kosher because the interact helper uses keypress
    $(SUBMENU_ITEMS).off('keydown', itemFocusListener);
    $(SUBMENU_ITEMS).on('keydown', itemFocusListener);
  }

  function computeScrollIndicators(level) {
    const menu = $(`.side-menu[data-level="${level}"]`);
    if (!menu.hasClass('open')) {
      return;
    }

    const scrollableArea = $('.side-menu__sub', menu);
    const scroll = scrollableArea.scrollTop();
    const height = scrollableArea[0].scrollHeight - scrollableArea.height();
    if (scroll < height - 1) {
      $('.side-menu__overflow:first', menu).addClass('show');
    } else {
      $('.side-menu__overflow:first', menu).removeClass('show');
    }
  }

  function openSubMenu(el, focusItem = false) {
    const item = $(el).closest('.side-menu__item').first();
    if (item.hasClass('selected')) {
      // no-op if already selected
      return;
    }

    const currMenu = $(item).closest('.side-menu');
    const level = currMenu.getLevel();
    const subMenu = $(`.side-menu[data-level="${level + 1}"]`);
    const onDeckMenu = $(`.side-menu[data-level="${level + 2}"]`);

    if (onDeckMenu.length) {
      // Keep on-deck hidden until sub menu has finished transitioning
      subMenu.on('webkitTransitionEnd transitionend otransitionend', () => {
        onDeckMenu.addClass('on-deck');
        subMenu.off('webkitTransitionEnd transitionend otransitionend');
      });
      onDeckMenu.removeClass('open');
    }
    navbarMenu.addClass(`level-${level + 1}`);
    navbarMenu.removeClass(`level-${level + 2}`);

    // Copy sub menu if there is one
    const subItems = $('.side-menu__items:first', item).clone();
    if (subItems.length) {
      subItems.removeClass('d-none');
      $('.side-menu__sub-header p', subMenu).html($('.side-menu__link-title', item).html());

      // Add parent link as first item in sub menu
      url = $('div:first', item).data('url');
      if (url) {
        subItems.prepend(`
          <li class="side-menu__item">
            <a href="${url}">
              <span class="side-menu__link-title">
                ${$('.side-menu__link-title', item).html()}
              </span>
            </a>
          </li>
        `);
      }
      $('.side-menu__sub', subMenu).html('');
      $('.side-menu__sub', subMenu).append(subItems);
    }

    // adding gradient to each sidebar for a scroll indicator
    $('.side-menu__sub', subMenu).append(
      '<img class="side-menu__overflow" src="/themes/custom/ukhc/images/scroll-gradient.png">',
    );

    $('.side-menu__item.selected', currMenu).removeClass('selected');
    item.addClass('selected');
    subMenu.addClass('open');

    // eslint-disable-next-line no-use-before-define
    addMenuListeners(level + 1);

    computeScrollIndicators(level + 1);

    if (focusItem) {
      $(SUBMENU_ITEMS, subMenu)[0].focus();
    }
  }

  function closeSubMenu(el) {
    const subMenu = $(el).closest('.side-menu');
    const level = subMenu.getLevel();

    // Add closing class during animation to hide focus background
    navbarMenu.removeClass(`level-${level}`);
    navbarMenu.addClass('closing');
    navbarMenu.on('webkitTransitionEnd transitionend otransitionend', () => {
      navbarMenu.removeClass('closing');
      navbarMenu.off('webkitTransitionEnd transitionend otransitionend');
    });

    // Close all menus from this level and up
    $('.side-menu').each(function () {
      const thisLevel = $(this).getLevel();
      if (thisLevel >= level) {
        $('.side-menu__item.has-children', this).off('keypress click mouseenter');
        $(this).off('webkitTransitionEnd transitionend otransitionend');
        $(this).removeClass('open on-deck');
        navbarMenu.removeClass(`level-${thisLevel}`);
      }
    });

    $('.side-menu__item').removeClass('selected');
  }

  // Manages tabbing within menu items
  function itemFocusListener(e) {
    const menu = $(e.target).closest('.side-menu');
    const item = $(e.target).closest('.side-menu__item')[0];
    const which = key(e);

    let allVisibleItems = $('.side-menu.open .side-menu__item').filter(':visible');
    if (item === allVisibleItems.first()[0] && which === keyCodes.tab && e.shiftKey) {
      // Back to toggle from first item
      e.preventDefault();
      navbarMenu.focus();
    } else if (item === allVisibleItems.last()[0] && which === keyCodes.tab && !e.shiftKey) {
      // Forward after latest item
      e.preventDefault();
      $('.header__logo-link').focus();
      navbarMenu.toggleNavbar();
    }

    // Simulate 'back' for shift+tab on first mobile submenu item
    if (isMobile() && menu.getLevel() !== 1 && which === keyCodes.tab && e.shiftKey) {
      const visibleItems = $('.side-menu__item', menu).filter(':visible');

      if (item === visibleItems.first()[0]) {
        e.preventDefault();
        $('.side-menu__back', menu).click();
        allVisibleItems = $('.side-menu.open .side-menu__item').filter(':visible');
        if (allVisibleItems.last().attr('role') === 'button') {
          allVisibleItems.last().focus();
        } else {
          $('a:first', allVisibleItems.last()).focus();
        }
      }
    }
  }

  // Add getLevel function to instances of side-menu
  $('.side-menu').each(function () {
    $(this).init.prototype.getLevel = function () {
      return parseInt($(this).data('level'), 10);
    };
  });
  $('.side-menu').click((e) => e.stopPropagation());

  // Close deeper submenus when hovering a menu item without children
  $('.side-menu').on('mouseenter', '.side-menu__item:not(.has-children)', function () {
    if (isMobile()) return;
    const menu = $(this).closest('.side-menu');
    const level = menu.getLevel();
    $('.side-menu__item.selected', menu).removeClass('selected');
    $('.side-menu').each(function () {
      const thisLevel = $(this).getLevel();
      if (thisLevel > level) {
        $(this).off('webkitTransitionEnd transitionend otransitionend');
        $(this).removeClass(thisLevel > level + 1 ? 'open on-deck' : 'open');
        navbarMenu.removeClass(`level-${thisLevel}`);
      }
    });
  });

  $('.side-menu__back').click(function () {
    closeSubMenu($(this));
  });

  // Setup scroll indicators for side menus
  $('.side-menu:not([data-level="0"])').each(function () {
    const level = $(this).getLevel();
    const scrollableArea = $('.side-menu__sub', this);

    // sidebar scroll for gradient indicator
    scrollableArea.scroll(function () {
      computeScrollIndicators(level);
    });

    // window resize for gradient indicator
    $(window).resize(function () {
      computeScrollIndicators(level);
    });
  });

  // Setup navbar menu
  navbarMenu.each(function () {
    $(SUBMENU_ITEMS).attr('tabindex', '-1');
    $(this).init.prototype.isNavbarOpen = function () {
      return $(this).attr('aria-expanded') === 'true';
    };

    $(this).init.prototype.toggleNavbar = function () {
      $(this).setNavbarOpen(!this.isNavbarOpen());
    };

    $(this).init.prototype.setNavbarOpen = function (open) {
      _ukhcSetNavDimActive(
        open,
        () => $(this).setNavbarOpen(false), // onStopDim
      );
      if (open) {
        $(SUBMENU_ITEMS).attr('tabindex', '0');
        $('.side-menu__sub').attr('tabindex', '0');
        $(this).attr('aria-label', 'Collapse navigation menu');
        $(this).attr('aria-expanded', 'true');
        $(this).css('z-index', 104);
        $('.side-menu').removeClass('notransition-onresize');
        $('.navbar-menu__label').html('Close');

        const levelZeroItem = $('.side-menu[data-level="0"] .side-menu__item');
        openSubMenu(levelZeroItem);
      } else {
        $(SUBMENU_ITEMS).attr('tabindex', '-1');
        $('.side-menu__sub').attr('tabindex', '-1');
        $(this).attr('aria-label', 'Expand navigation menu');
        $(this).attr('aria-expanded', 'false');
        $(this).css('z-index', 99);
        $('.side-menu').addClass('notransition-onresize');
        $('.navbar-menu__label').html('Menu');

        const levelOneItem = $('.side-menu[data-level="1"] .side-menu__item');
        closeSubMenu(levelOneItem);
      }
    };
  });
  navbarMenu.interact(() => navbarMenu.toggleNavbar());
  navbarMenu.keydown(function (e) {
    const which = key(e);
    if ($(this).isNavbarOpen()) {
      if (which === keyCodes.tab && !e.shiftKey) {
        // Forward to first item
        e.preventDefault();
        $(SUBMENU_ITEMS)[0].focus();
      } else if (which === keyCodes.tab && e.shiftKey) {
        // Back up before menu
        navbarMenu.toggleNavbar();
      }
    }
  });
  // Global esc toggles menu off
  $(document).keyup(function (e) {
    if (key(e) === keyCodes.esc) {
      if (navbarMenu.isNavbarOpen()) {
        navbarMenu.toggleNavbar();
      }
    }
  });

  // Disable transitions during window resize
  $('.side-menu').addClass('notransition-onresize');

  // Keep mobile menu height in sync with viewport / top nav height
  const htmlRo = new ResizeObserver(() => {
    const $siteHeader = $('.top-nav .header');
    if (!$siteHeader.length) {
      return;
    }

    const siteHeaderTop = $siteHeader[0].getBoundingClientRect().top;

    let locationSubNavTop = $siteHeader[0].getBoundingClientRect().bottom;
    const $subsiteNav = $('.subnav--subsite .subnav__navbar');
    if ($subsiteNav.length) {
      locationSubNavTop = $subsiteNav[0].getBoundingClientRect().bottom;
    }
    $('.subnav--location, .subnav--hospital').css('top', `${locationSubNavTop}px`);

    const $topNav = $('.top-nav');
    const jumpNavTop = $topNav.length
      ? $topNav[0].getBoundingClientRect().bottom
      : locationSubNavTop;

    $('.subnav--jump').css('top', `${jumpNavTop}px`);

    document.documentElement.style.setProperty(
      '--sticky-nav-offset',
      `${jumpNavTop}px`,
    );

    // Everything above --sticky-nav-offset plus the jump nav that sits on it,
    // so full-height components can clear the whole stack rather than sliding
    // underneath it. Consumed by .full-bleed-banner (scss/components/
    // _full_bleed_banner.scss) and js/libraries/full-bleed-banner.js.
    const $jumpNav = $('.subnav--jump');
    document.documentElement.style.setProperty(
      '--chrome-offset',
      `${jumpNavTop + ($jumpNav.length ? $jumpNav.outerHeight() : 0)}px`,
    );

    // Use CSS custom property to overcome issues with viewport units on mobile
    // credit: https://css-tricks.com/the-trick-to-viewport-units-on-mobile
    $('.side-menu').css('height', `calc((var(--vh, 1vh) * 100) - ${siteHeaderTop}px`);
  });

  htmlRo.observe($('html')[0]);

  if ($('.top-nav').length) {
    htmlRo.observe($('.top-nav')[0]);
  }
});
